webpackJsonp([8],{

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(644);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe49a09_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(654);
var normalizeComponent = __webpack_require__(169)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fe49a09_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      teste: "",
      nomeEmpresa: ""
    };
  },
  created: function created() {
    var currentUrl = window.location.hostname;
    var imgUrl = currentUrl.split(".");
    console.log(this.imgUrl);
    if (imgUrl[0] == "omminiprepago") {
      this.nomeEmpresa = "OMMINI";
    } else {
      this.nomeEmpresa = imgUrl[0].toUpperCase();
    }
    //console.log(this.imgTopo);
  },

  methods: {
    entrar: function entrar() {
      this.$router.push("Login");
    }
  }
});

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"color":"primary"}},[_c('v-card-text',{staticClass:"display-2 white--text tpx-0"},[_vm._v("Bem-vindo ao "+_vm._s(_vm.nomeEmpresa)+" Pré-Pago")])],1),_vm._v(" "),_c('v-flex',{staticClass:"headline",attrs:{"xs10":"","offset-xs1":""}}),_vm._v(" "),_c('v-flex',{staticClass:"body-2 font-weight-regular font-italic",staticStyle:{"margin-top":"100px"},attrs:{"xs10":"","offset-xs1":""}},[_c('p'),_vm._v(" "),_c('p',[_vm._v("Seja bem-vindo ao Sistema "+_vm._s(_vm.nomeEmpresa)+" Pré-Pago!")]),_vm._v(" "),_c('p',[_vm._v("Seu cartão virtual será gerado ao inserir crédito pela primeira vez.")]),_vm._v(" "),_c('p',[_vm._v("\n        O crédito inicial e as demais recargas poderão ser feitas em uma de nossas lojas ou pelo APP para Android ou IOS. Então,\n        não perca tempo! Baixe o aplicativo "+_vm._s(_vm.nomeEmpresa)+" Pré-Pago pela Play Store ou App Store!\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"sucesso","value":"justify"},on:{"click":function($event){_vm.entrar()}}},[_vm._v("\n        Acessar\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.e8aa7b913350c65b4204.js